import * as React from "react";
import { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import Paper from "@mui/material/Paper";
import Layout from "../../layout/Main/Layout";
import { Typography, Modal, Box } from "@mui/material";
import { get, del } from "../../config/axios";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";

const UserQueries = () => {
    const [rows, setRows] = useState([]);
    const [open, setOpen] = useState(false);
    const [selectedQuery, setSelectedQuery] = useState(null);

    const handleOpen = (query) => {
        setSelectedQuery(query);
        setOpen(true);
    };

    const handleClose = () => setOpen(false);

    const columns = [
        { field: "id", headerName: "S. No", width: 70 },
        { field: "fullName", headerName: "Full Name", width: 130 },
        { field: "age", headerName: "Age", width: 70, type: "number" },
        { field: "email", headerName: "Email Address", width: 200 },
        { field: "phone", headerName: "Phone Number", width: 120 },
        { field: "subject", headerName: "Subject", width: 180 },
        { field: "description", headerName: "Description", width: 250 },
        {
            field: "view",
            headerName: "View",
            width: 90,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) => (
                <IconButton
                    aria-label="view"
                    onClick={() => handleOpen(params.row)}
                    color="primary"
                >
                    <VisibilityIcon />
                </IconButton>
            ),
        },
        {
            field: "actions",
            headerName: "Action",
            width: 100,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) => (
                <IconButton
                    aria-label="delete"
                    onClick={() => handleDelete(params.row._id)}
                    color="error"
                >
                    <DeleteIcon />
                </IconButton>
            ),
        },
    ];

    const fetchQueries = async () => {
        try {
            const data = await get("/api/dashboard/website/user-queries");
            setRows(data.map((query, index) => ({ ...query, id: index + 1 })));
        } catch (error) {
            console.error("Error fetching queries:", error);
        }
    };

    const handleDelete = async (queryId) => {
        try {
            await del(`/api/dashboard/website/user-queries/${queryId}`);
            fetchQueries();
        } catch (error) {
            console.error("Error deleting query:", error);
        }
    };

    useEffect(() => {
        fetchQueries();
    }, []);

    const paginationModel = { page: 0, pageSize: 5 };

    return (
        <Layout>
            <div style={{ padding: "1rem" }}>
                <Typography variant="h5" paddingY={2}>User Queries</Typography>
                <Paper sx={{ width: '100%' }}>
                    <DataGrid
                        rows={rows}
                        columns={columns}
                        initialState={{ pagination: { paginationModel } }}
                        pageSizeOptions={[5, 10]}
                        sx={{
                            border: 0,
                            '& .MuiDataGrid-columnHeaderTitle': {
                                fontWeight: 'bold',
                            },
                        }}
                    />
                </Paper>

                <Modal open={open} onClose={handleClose}>
                    <Box
                        sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            width: 700,
                            bgcolor: 'background.paper',
                            borderRadius: 2,
                            boxShadow: 24,
                            p: 4,
                        }}
                    >
                        <Typography variant="h6" fontWeight="bold" gutterBottom>
                            {selectedQuery?.subject}
                        </Typography>
                        <Typography>{selectedQuery?.description}</Typography>
                    </Box>
                </Modal>
            </div>
        </Layout>
    );
};

export default UserQueries;
